import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/services";

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 bg-[#0A0A0C] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="max-w-2xl mb-14">
          <p className="text-xs uppercase tracking-[0.28em] text-[#D4AF37] font-semibold mb-3">
            What clients say
          </p>
          <h2 className="text-3xl md:text-5xl font-semibold tracking-tighter text-white">
            Trusted by hundreds
            <span className="block text-white/55">of Atlanta homes.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="relative p-7 md:p-8 rounded-2xl bg-[#121216] border border-white/10 hover:border-[#D4AF37]/40 transition-all duration-300"
            >
              <Quote
                size={28}
                className="text-[#D4AF37]/40 absolute top-6 right-6"
                strokeWidth={1.5}
              />
              <div className="flex gap-0.5 mb-5">
                {Array.from({ length: t.rating }).map((_, idx) => (
                  <Star
                    key={idx}
                    size={15}
                    className="text-[#D4AF37]"
                    fill="#D4AF37"
                  />
                ))}
              </div>
              <p className="text-white/80 text-[15px] leading-relaxed">
                "{t.quote}"
              </p>
              <div className="mt-6 pt-5 border-t border-white/10">
                <div className="text-white font-semibold">{t.name}</div>
                <div className="text-xs text-white/50 mt-1">
                  {t.location} · {t.service}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
